export const SodiumTargets = ['Target 1', 'Target 2'];
export const SodiumLevelObj = {
    mealPrgram: "",
    targetType: "",
    enabled: false,
    details: []
};
export const ProductionRecordSettingObj = {
    mealSchoolId: 0,
    ovsEnabled: false,
    leftOverCodeEnabled: false
};
export const NaSettingsObj = {
    catererAnalysisId: 0,
    wgrLimit: undefined,
    fruitLimit: undefined,
    sodiumLevel: {},
    productionRecordSettings: {},
}
